import ViewConstructor from './../components/ViewConstructor';
import Cookie from 'js-cookie';

import { getUrlParameter } from './../../_util.js';

/** class representing the details page */
class DetailsPage extends ViewConstructor {

  /**
  componentDidMount - override method
  */
  componentDidMount() {
    this.updateState({
      apiUrl: '',
      prevCase: {},
      nextCase: {},
    });
  }

  componentDidEnter() {
    super.componentDidEnter();
    this.resetCase();
    $(window).trigger('details-page-enter');
  }

  resetCase() {
    var $ref = $(`#${ this.state.generatedId }`);
    var mainImage = $ref.find('.details__main__img img');

    if (mainImage) {
      mainImage.attr('src', '');
      $ref.find('.details__others__photo').remove();
    }
  }

  /**
  @param {state} - can contain the case, api, gallery
  If the state includes a case, this will imediately render it, otherwise it create a request via the API for the case id specified in the URL, then it will refire this same method with the case returned from the API as part of it's parameter. 
  */
  loadSection(state = {}) {
    const that = this;

    this.updateState(state);

    if (this.state.case) {

      let currentCategoryName = '';
      if (this.state.case !== undefined) {
        let canonical_url = this.state.case.canonical_url;

        this.state.case.case_categories.map((category) => {
          if (canonical_url.indexOf(category.category_canonical_url) !== -1) {
            currentCategoryName = category.category_name;
          }
        });
        let metaTitle = `${ currentCategoryName } Before & After Photos Patient ${this.state.case.case_id} | ${this.state.gallery.state.practice.locality.city}, ${this.state.gallery.state.practice.locality.state} | ${this.state.gallery.state.practice.name}`;
        let metaDescription = `View ${currentCategoryName} before-and-after photos of ${this.state.gallery.state.practice.name}'s patient ${this.state.case.case_id}`;

        this.updateMeta(metaTitle, metaDescription);
        that.updateCanoncial(window.location.origin + this.state.case.canonical_url);
      }

      let galleryUser = Cookie.getJSON('gallery-user');

      let isAFavoriteCase = false;

      if (galleryUser) {
        galleryUser.favorites.map((singleCase) => {
          if (parseInt(singleCase, 10) === this.state.case.case_id) {
            isAFavoriteCase = true;
          }
        });
      }

      let templateContent = {
        title: this.state.case.case_title || (currentCategoryName !== undefined ? currentCategoryName + ' ' : '') + 'Case ' + this.state.case.case_id,
        photos: this.generateSrcsetPhotos(this.state.case.views),
        attr: this.generateAttributeDetails(this.state.case.case_attributes),
        description: (this.state.case.case_description) ? this.state.case.case_description : '',
        video: this.state.case.case_video,
        id: this.state.case.case_id,
        isAFavoriteCase: isAFavoriteCase,
      };
      if(templateContent.attr === '' && templateContent.description === '')
        $('.details__attributes').slideUp();
      else
        $('.details__attributes').slideDown();

      this.template(templateContent);
      this.setMainImage();
      if (this.state.case.sequence_value !== undefined) {
        this.getPreviousAndNextCase();
      } else {
        this.getThisCategoryCases();
      }
    } else {
      let brokenPath = window.location.pathname.split('/');
      let caseId = brokenPath[brokenPath.length - 1];
      
      this.state.api.getCaseById(caseId, (res) => {
        that.loadSection({
          case: res,
        });
      });
    }
  }

  /**
    This will only get fired when the details page is loaded while the user has not gone down the normal route. e.g. user it linked to a case page.

    A) This will do is make a network request to the API and for all cases witin the category (10 at a time), and loop through the cases being returned. 
    A 1) If the case doesn't exist within the returned amount of case it will make another request incrementing the current returned position and run through step A again.
    A 2) IF case was found, it will update the current state with the returned case and category ID then reload the current section. 

    Why is this necessary? When I make a targeted request to the API for a single case, it doesn't return the sequence value of the current case. I need to call this in order to determine if the "prev/next" buttons should display. 
  */
  getThisCategoryCases() {
    const that = this;
    let categoryUrl = that.state.gallery.state.currentCategoryCanonical;
    if( categoryUrl === undefined ) {
      let windowPathname = window.location.pathname.split('/');
      
      if (windowPathname[windowPathname.length - 1] === "") {
        windowPathname.pop();
      }

      if (typeof parseInt(windowPathname[windowPathname.length -1], 10) === 'number') {
        windowPathname.pop();
      }

      categoryUrl = windowPathname.join('/');
    };
   
    let reqObj = {
      category_url: categoryUrl,
      first_returned_position: 1,
      case_count: 100,
    };
    let urlOfCurrentCase = window.location.pathname;
    let urlSplit = urlOfCurrentCase.split('/');

    if (urlSplit[urlSplit.length - 1] === '') {
      urlSplit.pop();
      urlOfCurrentCase = urlSplit.join('/');
    }
    getCurrentCase(reqObj);

    function getCurrentCase(request) {
      that.state.api.getCases(request, (res) => {
        if (that.enabled && res && res.case_count) {
          let cases = res.cases;
          let foundCase = false;

          for (let i = 0; i < cases.length; i++) {
            let currentCase = cases[i];
            if (currentCase.canonical_url === urlOfCurrentCase) {
              foundCase = true;
              that.updateState({
                case: currentCase
              });
              that.state.gallery.update({ cases: res });
            }
          }

          if (foundCase) {
            that.loadSection();
          } else {
            reqObj.first_returned_position += reqObj.case_count;
            getCurrentCase(reqObj);
          }
        }
      });
    }
  }

  /**
  Prerendering! Based on the current category and case, this will reach out to the API on load (after initial data of page has loaded) and get the prev/next cases. We can prerender here because we want the user to through the cases
  */
  getPreviousAndNextCase() {
    const that = this;
    let currentCategory = this.state.currentCategory || this.state.gallery.state.cases.category_id;
    let currentCaseSequence = this.state.case.sequence_value;

    let isFavorites = getUrlParameter('favorites');

    if (isFavorites) {
      let galleryUser = Cookie.getJSON('gallery-user');
      let currentCaseIndex = galleryUser.favorites.indexOf(this.state.case.case_id);

      let nextFavCaseRequest = galleryUser.favorites[currentCaseIndex + 1];
      let prevFavCaseRequest = galleryUser.favorites[currentCaseIndex - 1];

      if (nextFavCaseRequest) {
        this.state.api.getCaseById(nextFavCaseRequest, (res) => {
          that.updateState({
            nextCase: res,
          });
        });
      } else {
        this.updateState({
          nextCase: undefined,
        });
      }

      if (prevFavCaseRequest) {
        this.state.api.getCaseById(prevFavCaseRequest, (res) => {
          that.updateState({
            prevCase: res,
          });
        });
      } else {
        this.updateState({
          prevCase: undefined,
        }); 
      }

    } else {
      let nextCaseRequest = {
        category_id: currentCategory,
        first_returned_position: currentCaseSequence + 1,
        case_count: 1,
      };

      let prevCaseRequest = {
        category_id: currentCategory,
        first_returned_position: currentCaseSequence - 1,
        case_count: 1,
      };

      this.state.api.getCases(nextCaseRequest, (res) => {
        if (this.enabled && res.case_count === 1) {
          that.updateState({
            nextCase: res.cases[0],
          });
        }
      });
      this.state.api.getCases(prevCaseRequest, (res) => {
        if (this.enabled && res.case_count === 1) {
          that.updateState({
            prevCase: res.cases[0],
          });
        }
      });
    }
  }

  /**
    Here will be where ALL the event listeners will be added when this page loads. 
    - It is responsable for when the user selects the "others" and will make it the "main" phone. 
    - This also binds the "prev/next" buttons to  fire the handleDetailsNavigation method with the current action.
  */
  addDetailsEventListeners() {
    let ref = $(`#${ this.state.generatedId }`);
    const that = this;

    ref.find('.details__others__photo').off().on('click', function() {
      let children = $(this).find('.row').children();

      $(this).siblings().removeClass('active');
      $(this).addClass('active');
      $(window).trigger('case-view-changed');
      that.setMainImage(children);
    });

    $('.details__navigation__btn').off().on('click', function(e) {
      if (e) { e.preventDefault(); }

      let nextAction = $(this).attr('data-action');

      if (nextAction) {
        $(window).trigger('case-changed');
        that.handleDetailsNavigation(nextAction);
      }
    });
  }

  /**
  This method is fired when the navigation on the details page is clicked. 
  @param {action} - data attribute of the action the button is to be performed on. 
  
  It checks to see what the current case.sequence_value is. Then drops the current action into a switch statement. 
  - next: checks if currentCaseSequence + 1 is less than or equal to the total cases in the category, then it loads the next case (that was loaded) and updates the URL via the history API.
  - prev: checks if currentCaseSequence - 1 is greater than or equal to 1; if so, it loads the previous case (that was preloaded) and fires the loadSection method and updates the URL via the history API.
  */
  handleDetailsNavigation(action) {
    const that = this;
    let currentCaseSequence = this.state.case.sequence_value;
    let userFavorites = getUrlParameter('favorites') ? '?favorites=true' : '';

    //this.toggleLoading(true);

    switch(action.toLowerCase()) {
      case 'back':
        break;
      case 'next':
        let totalCases = this.state.gallery.state.cases.cases_available;
        if (currentCaseSequence + 1 <= totalCases || getUrlParameter('favorites')) {
          history.pushState(window.location.pathname, 'state', that.state.nextCase.canonical_url + userFavorites);

          that.loadSection({
            case: that.state.nextCase,
          });
        }
        break;
      case 'prev':
        if (currentCaseSequence - 1 >= 1 || getUrlParameter('favorites')) {
          history.pushState(window.location.pathname, 'state', that.state.prevCase.canonical_url + userFavorites);
          that.loadSection({
            case: that.state.prevCase,
          });
        }
        break;
      default:
        break;
    }
  }

  /**
  Fired during the loadSection method
  @param {views} - array of images for a case.

  This will loop through all views (potentially multiple images in each view) and in each view there will be 4 returned image sizes, this creates the html5 srcset data attribute so the browser can determine which image size to display. 
  */
  generateSrcsetPhotos(views) {

    let orderedViews = views.sort((a, b) => a.view_number - b.view_number);

    let allImages = '';

    orderedViews.map((view, viewIndex) => {
      let classNames = '';
      if (viewIndex === 0) {
        classNames += 'active';
      }
      let viewWrapper = `<div data-index="${ viewIndex }" class="details__others__photo ${ classNames }"><div class="row collapse">`;
      
      for (let i = 0; i < view.images.length; i++) {
        let currentImage = view.images[i];

        let thumbnail = currentImage.srcset.filter((imageItem) => imageItem.size.toLowerCase() === 'thumbnail')[0].path || undefined;
        let defaultThumbnail = currentImage.srcset.filter((imageItem) => (imageItem.size.toLowerCase() === 'detail'))[0].path || undefined;
        let detail = currentImage.srcset.filter((imageItem) => imageItem.size.toLowerCase() === 'huge')[0].path || undefined;

        let singleImage = `<div data-large="${this.state.apiUrl}${ detail }" data-caption="${ currentImage.caption || currentImage.type }" data-photo-type="${currentImage.type}" class="columns"><img 
        src="${ this.state.apiUrl }${ thumbnail }" 
        srcset="${this.state.apiUrl}${ defaultThumbnail } 1x,
        ${this.state.apiUrl}${ detail } 2x"
        alt="${this.state.gallery.state.cases.category_name || 'Patient'} ${currentImage.type} Photo | ${this.state.gallery.state.practice.locality.city}, ${this.state.gallery.state.practice.locality.state} | ${this.state.gallery.state.practice.name}"
        title="${this.state.gallery.state.cases.category_name || 'Patient'} ${currentImage.type} Photo | ${this.state.gallery.state.practice.locality.city}, ${this.state.gallery.state.practice.locality.state} | ${this.state.gallery.state.practice.name}" />
        </div>`;

        viewWrapper += singleImage;
      }

      viewWrapper += `</div><div>View ${ viewIndex + 1 } of ${ orderedViews.length }</div></div>`;

      allImages+= viewWrapper;
    });

    return allImages;
  }

  /**
    Sets the "main" image of the case. 
    @param - {object} - $children of jQuery selector

    - If no children are passed in, it will get the first set of images and set those as the main image.
    - If images are passed in it will loop through and get the "data-large" version of the image and update the current "main" images. 

    There's an animate height that checks the current images height and hardcodes the height of the container. Then once the images are loaded, it then animates the containers height to the new height of the "main" images.
  */
  setMainImage($children) {
    let $ref = $(`#${ this.state.generatedId }`);
    let images = '<div class="details__main--row">';
    let hasBeenCalled = false;

    if ($children === undefined) {
      $children = $ref.find('.details__others__photo').first().find('.row').children();
    }

    const that = this;

    $children.each(function(index, child) {
      let imageUrl = $(child).attr('data-large');
      let imageType = $(child).attr('data-photo-type');
      let imageCaption = $(child).attr('data-caption');

      let mainImageTemplate = `
      <div class="details__main__img">
        <img src="${imageUrl}"
        alt="${that.state.gallery.state.cases.category_name || 'Patient'} ${imageType || ''} Photo | ${that.state.gallery.state.practice.locality.city}, ${that.state.gallery.state.practice.locality.state} | ${that.state.gallery.state.practice.name}"
        title="${that.state.gallery.state.cases.category_name || 'Patient'} ${imageType || ''} Photo | ${that.state.gallery.state.practice.locality.city}, ${that.state.gallery.state.practice.locality.state} | ${that.state.gallery.state.practice.name}"
        />
        <p>${ imageCaption }</p>
      </div>`;

      images += mainImageTemplate;
    });

    images += '</div>';

    let $main = $ref.find('.details__main');

    $main.css({
      height: $main.outerHeight() || 'auto',
    });

    $main.html(images);

    function animateHeight(){
      let height = $main.find('.details__main--row').outerHeight();
      if (!hasBeenCalled) {
        hasBeenCalled = true;
        $main.animate({
          height: height,
        }, 250);

        setTimeout(() => {
          $main.css({
            height: 'auto',
          }); 
        }, 300);
      }
    }

    $main.find('.details__main__img img').on('load', animateHeight);
  }
  
  /**
  @param {attributes} - array of attributes
  This is fired in the `loadSection` method. 

  This will loop through all the attributes and pumps them into a table. 
  */
  generateAttributeDetails(attributes) {
    let allAttr = '';
    attributes.map((attr) => {
      if (attr.active && (attr.attribute_value !== '' && attr.attribute_value !== null)) {
        switch(attr.attribute_name) {
          case "Height":
            if(attr.attribute_value.length === 0 ||  attr.attribute_value == 0)
              attr.attribute_value = "n/a";
            else
              attr.attribute_value = Math.floor(attr.attribute_value/12) + " ft " + (attr.attribute_value%12) + " in";
        }        
        let attributeTemplate = `<tr>
        <th>${ attr.attribute_name }</th>
        <td>${ attr.attribute_value }</td>
        </tr>`;

        allAttr += attributeTemplate;
      }

    });

    return allAttr;
  }

  /**
    @param {content} - Template for the details page. 
    - Checks if is last or first case to add the disabled state to the details navigation. 
    - Checks to see if the gallery has the currentCategoryCanonical link defined in the gallery state, if it is, it sets the back button to it, otherwise it parses the current case URL and removes the case id and appends it as the back button href. 
  */
  template(content) {
    const that = this;
    let $ref = $(`#${ this.state.generatedId }`);
  
    let isLastCase = (that.state.case.sequence_value && that.state.case.sequence_value !== that.state.gallery.state.cases.cases_available) ? '' : 'disabled';
    let isFirstCase = (that.state.case.sequence_value && that.state.case.sequence_value !== 1) ? '' : 'disabled';
    
    if (getUrlParameter('favorites')) {
      var user = this.cookie.getJSON('gallery-user');
      
      if (user.favorites.indexOf(this.state.case.case_id) + 1 === user.favorites.length) {
        isLastCase = 'disabled';
      } else {
        isLastCase = '';
      }

      if (user.favorites.indexOf(this.state.case.case_id) === 0) {
        isFirstCase = 'disabled';
      } else {
        isFirstCase = '';
      }
    }

    let windowPathname = window.location.pathname.split('/');
    let currentCategory = windowPathname.reverse().slice(1, windowPathname.length).reverse().join('/');

    let cameFromFavorites = getUrlParameter('favorites');

    // Set up the back button - we have to look up the category name of the category we came from
    let currentCategoryName = undefined;
    let currentCategoryCanonical = undefined;

    let categoryLookup = this.state.gallery.state.categories.map(category => category.subcategories.map((subcategory) => {
      if(this.state.gallery.state.currentCategoryCanonical === undefined && subcategory.category_canonical_url == currentCategory) {
        currentCategoryName = subcategory.category_name;
        currentCategoryCanonical = subcategory.category_canonical_url;
        that.updateState({
          currentCategory: subcategory.category_id
        });
      } else if(subcategory.category_canonical_url == this.state.gallery.state.currentCategoryCanonical) {
        currentCategoryName = subcategory.category_name;
        currentCategoryCanonical = subcategory.category_canonical_url;
        that.updateState({
          currentCategory: subcategory.category_id
        });
      }
    }));

    let backButton = this.state.gallery.state.currentCategoryCanonical || currentCategoryCanonical;
    let backButtonText = (cameFromFavorites) ? "Favorites" : currentCategoryName === undefined ? "Gallery" : currentCategoryName + " Gallery";

    if (cameFromFavorites) {
      backButton = `${ this.state.gallery.state.baseUrl }/my-account/favorites`;
    }

    updateTitle(content.title, this.state.gallery.state.galleryTitle);
    updateOtherPhotos(content.photos);
    updateFavoritesData(content.isAFavoriteCase, content.id);
    updateAttr(content.attr);
    updateDescription(content.description);
    updateVideo(content.video);
    updateNavigation(isFirstCase, isLastCase, backButton, backButtonText);

    // $ref.html(template);
    $ref.find('.details__center-content__btn').html(this.cloneConsultationButton());
    this.state.gallery.addLinkEventListeners();
    this.cloneDetailsNavigation();
    this.addDetailsEventListeners();
    //this.toggleLoading(false);

    function updateTitle(title, subtitle) {
      //$ref.find('.details__title').text(title);
      $('#photo-gallery__title').text(title);
      $('#photo-gallery__subtitle').html(subtitle);
    }

    function updateOtherPhotos(photos) {
      $ref.find('.details__others').html(photos);
    }

    function updateFavoritesData(isAFavorite, caseId) {
      var $favRef = $ref.find('.gallery-favorites');
      if (isAFavorite) {
        if (!$favRef.hasClass('active')) {
          $favRef.addClass('active');
        }
        if (!$favRef.find('.heart-icon').hasClass('active')) {
          $favRef.find('.heart-icon').addClass('active');
        }
      } else {
        $favRef.find('.heart-icon').removeClass('active');
        $favRef.removeClass('active');
      }

      $favRef.attr('data-id', caseId);
    }

    function updateAttr(attr) {
      $ref.find('.details__attributes table.data').html(attr);
    }

    function updateDescription(desc) {
      $ref.find('.details__content').html(desc);
    }

    function updateVideo(video) {
      if (video) {
        $ref.find('.details__video').html(video);
      }
    }

    function updateNavigation(isFirstCase, isLastCase, backButtonLink, backButtonText) {
      if (isFirstCase === '') {
        $ref.find('.details__navigation__btn.prev').removeClass('disabled');
      } else {
        if (!$ref.find('.details__navigation__btn.prev').hasClass('disabled')) {
          $ref.find('.details__navigation__btn.prev').addClass('disabled');
        }
      }

      if (isLastCase === '') {
        $ref.find('.details__navigation__btn.next').removeClass('disabled');
      } else {
        if (!$ref.find('.details__navigation__btn.next').hasClass('disabled')) {
          $ref.find('.details__navigation__btn.next').addClass('disabled');
        }
      }

      $ref.find('.details__navigation__link').attr('href', backButtonLink);
      $ref.find('.details__navigation__link').text('Back to ' + backButtonText);
    }
  }

  /**
  This is responsible for cloning the "Previous" and "next" buttons into the topbar on the details page.

  WARNING -- breaking conduct here -- Cloning some elements into another component (topbar to be specific). 
  */
  cloneDetailsNavigation() {
    let $ref = $(`#${ this.state.generatedId }`);
    let allNavigation = $ref.find('.details__navigation').clone(true);
    let backToSearchButton = $ref.find('.details__navigation__link.back').clone(true);

    let $topbar = $('#topbar-mount');

    $topbar.find('.topbar__account__backtosearch').html(backToSearchButton);
    $topbar.find('.topbar__details__navigation').html(allNavigation);
  }

  /**
  Override the ViewConstructor render function.
  */
  render() {
    return `
      <div class="details">
        <p><em>*Keep in mind that each patient is unique and your results may vary.</em></p>
        
        <div class="details__main"></div>
        <div class="details__others">
          
        </div>
        
        <div class="details__center-content">
          <p class="favorites gallery-favorites " data-id=""><span class="heart-icon "> <strong class="add">Add to favorites</strong> <strong class="favorite">Favorited</strong></span></p>      
    
          <div class="details__center-content__btn"></div>

          <hr />
        </div>
        
        <div class="details__attributes">
          <h2>Case Details</h2>
          <div class="details__content">
            
          </div>
          <table class="data">
            
          </table>
        </div>

        <div class="details__video">
          
        </div>

        <p><em>*Keep in mind that each patient is unique and your results may vary. Photos in our online gallery are of actual patients of our practice who have provided consent to display their pictures online.</em></p>

        <hr />

        <div class="details__navigation">
          <a class="details__navigation__btn prev " data-action="prev">Previous Case</a>
          <a class="details__navigation__btn next " data-action="next">Next Case</a>
          <a href="" class="details__navigation__link back" data-action="back">Back to </a>
        </div>
      </div>
    `;
  }
}

export default DetailsPage;


// WEBPACK FOOTER //
// ./src/scripts/site/gallery-views/DetailsPage.js